module.exports = __webpack_public_path__ + "static/media/freight-forward-header.9f86ca24.png";